import { useQuery } from "@tanstack/react-query";
import { apiRequest } from "@core/services/api/apiRequest";
import type { Organization } from "../organization.types";

type Args = {
  organizationId: number;
  enabled?: boolean;
};

/**
 * Fetch organization data by ID.
 */
export function useFetchOrganization({ organizationId, enabled = true }: Args) {
  return useQuery({
    queryKey: ["organization", organizationId],
    queryFn: async () => {
      return await apiRequest(
        `/organization/${organizationId}/`,
        "GET"
      ) as Organization;
    },
    enabled: enabled && !!organizationId,
  });
}

